import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import RentalPlan from '../helpers/rental_plan'
import SalePlan from '../helpers/sale_plan'
import LensrentalsHD from './lensrentals_hd'
import Checkout from './checkout'

import styles from '../../assets/stylesheets/pages/cart/shipping.module.scss'

const Shipping = props => {
  const {
    className,
    cartPlan
  } = props

  const {
    cart,
    hdEligible,
    hdEnrolled
  } = cartPlan

  const isRental = cartPlan.type === 'rental'

  return (
    <section
      className={cx(
        className,
        'shipping',
        styles.shipping
      )}
      id='shipping'
    >
      {!!cart.length && isRental && (hdEligible !== false && hdEnrolled !== true) && (
        <LensrentalsHD
          cartPlan={cartPlan}
        />
      )}

      <Checkout
        cartPlan={cartPlan}
      />
    </section>
  )
}

Shipping.propTypes = {
  className: PropTypes.string,
  cartPlan: PropTypes.oneOfType([
    PropTypes.instanceOf(RentalPlan),
    PropTypes.instanceOf(SalePlan)
  ]).isRequired
}

export default Shipping
